import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { space, device } from '@ticketswap/solar'

const commonLayoutStyles = css`
  position: relative;
  margin-block: 0;
  margin-inline: auto;
  padding-inline-start: ${space[16]};
  padding-inline-end: ${space[16]};

  @media ${device.tablet} {
    padding-inline-start: ${space[32]};
    padding-inline-end: ${space[32]};
  }
`

export const NarrowPageLayout = styled.div`
  ${commonLayoutStyles};
  max-width: ${space[768]};
`

export const WidePageLayout = styled.div`
  ${commonLayoutStyles};
  max-width: ${960 / 16}rem;

  @media ${device.laptopM} {
    max-width: ${1128 / 16}rem;
  }
`
